import React from "react";

const Badges = ({ tags }) => {
  return (
    <div className="flex gap-x-[15px] gap-y-[10px] pb-6">
      {/* Best Seller Badge */}
      <div>
        <div className="badge px-[15px] py-[8px] text-[11px] bg-green-400 text-dark-1 font-normal
        rounded-full">
          BEST SELLER
        </div>
      </div>
      
      {/* New Badge */}
      <div>
        <div className="badge px-[15px] py-[8px] text-[11px] bg-red-1 text-white font-normal
        rounded-full">
          NEW
        </div>
      </div>
      
      {/* Popular Badge */}
      <div>
        <div className="badge px-[15px] py-[8px] text-[11px] bg-indigo-500 text-white font-normal
        rounded-full">
          POPULAR
        </div>
      </div>
    </div>
  );
};

export default Badges;